/** Keep full ABAP out of the chat thread; artifacts panel holds the program. */

const SESSION_START_PREFIX = '[Session start]';

/** Hide system rows and internal session-bootstrap text from the UI. */
export function isHiddenChatMessage(msg) {
  if (!msg) return true;
  const role = String(msg.role || '').toLowerCase();
  if (role === 'system') return true;
  const text = String(msg.content || '').trim();
  if (!text) return role !== 'user';
  if (text.startsWith(SESSION_START_PREFIX)) return true;
  if (text.includes('opened a new chat session for ABAP code generation')) {
    return true;
  }
  if (
    role === 'assistant' &&
    /greet briefly and ask your first focused clarifying question/i.test(text)
  ) {
    return true;
  }
  return false;
}

export const ABAP_ARTIFACT_PLACEHOLDER =
  'ABAP generation complete. View and copy the program in the Generated ABAP panel on the right.';

const ABAP_MARKERS = ['REPORT ', 'PROGRAM ', 'DATA:', 'FORM ', 'METHOD ', 'INCLUDE ', 'SELECT '];

function looksLikeAbapSource(text) {
  if (!text || text.length < 400) return false;
  return ABAP_MARKERS.some((m) => text.includes(m));
}

/**
 * @param {string} content
 * @param {{ role?: string, generatedCode?: string | null, phase?: string }} opts
 */
export function displayChatMessageContent(content, opts = {}) {
  const role = (opts.role || 'assistant').toLowerCase();
  if (role === 'user') return content || '';

  const text = (content || '').trim();
  if (!text) return content || '';

  const code = (opts.generatedCode || '').trim();
  if (code && text === code) return ABAP_ARTIFACT_PLACEHOLDER;
  if (code && text.length > 200 && text.includes(code)) return ABAP_ARTIFACT_PLACEHOLDER;

  const phase = (opts.phase || '').toUpperCase();
  if ((phase === 'DONE' || phase === 'GENERATE') && looksLikeAbapSource(text)) {
    return ABAP_ARTIFACT_PLACEHOLDER;
  }

  return content;
}
